/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { billingSubscriptionChangePlanPost$Json } from '../fn/subscription/billing-subscription-change-plan-post-json';
import { BillingSubscriptionChangePlanPost$Json$Params } from '../fn/subscription/billing-subscription-change-plan-post-json';
import { billingSubscriptionChangePlanPost$Plain } from '../fn/subscription/billing-subscription-change-plan-post-plain';
import { BillingSubscriptionChangePlanPost$Plain$Params } from '../fn/subscription/billing-subscription-change-plan-post-plain';
import { billingSubscriptionGet$Json } from '../fn/subscription/billing-subscription-get-json';
import { BillingSubscriptionGet$Json$Params } from '../fn/subscription/billing-subscription-get-json';
import { billingSubscriptionGet$Plain } from '../fn/subscription/billing-subscription-get-plain';
import { BillingSubscriptionGet$Plain$Params } from '../fn/subscription/billing-subscription-get-plain';
import { billingSubscriptionUpdateSeatsPost$Json } from '../fn/subscription/billing-subscription-update-seats-post-json';
import { BillingSubscriptionUpdateSeatsPost$Json$Params } from '../fn/subscription/billing-subscription-update-seats-post-json';
import { billingSubscriptionUpdateSeatsPost$Plain } from '../fn/subscription/billing-subscription-update-seats-post-plain';
import { BillingSubscriptionUpdateSeatsPost$Plain$Params } from '../fn/subscription/billing-subscription-update-seats-post-plain';
import { SubscriptionDto } from '../models/subscription-dto';

@Injectable({ providedIn: 'root' })
export class SubscriptionApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `billingSubscriptionGet()` */
  static readonly BillingSubscriptionGetPath = '/billing/subscription';

  /**
   * Get current subscription.
   *
   * Returns subscription, plan and seat assignments for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSubscriptionGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingSubscriptionGet$Plain$Response(params?: BillingSubscriptionGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    const obs = billingSubscriptionGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get current subscription.
   *
   * Returns subscription, plan and seat assignments for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSubscriptionGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingSubscriptionGet$Plain(params?: BillingSubscriptionGet$Plain$Params, context?: HttpContext): Observable<SubscriptionDto> {
    const resp = this.billingSubscriptionGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /**
   * Get current subscription.
   *
   * Returns subscription, plan and seat assignments for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSubscriptionGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingSubscriptionGet$Json$Response(params?: BillingSubscriptionGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    const obs = billingSubscriptionGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get current subscription.
   *
   * Returns subscription, plan and seat assignments for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSubscriptionGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingSubscriptionGet$Json(params?: BillingSubscriptionGet$Json$Params, context?: HttpContext): Observable<SubscriptionDto> {
    const resp = this.billingSubscriptionGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `billingSubscriptionChangePlanPost()` */
  static readonly BillingSubscriptionChangePlanPostPath = '/billing/subscription/change-plan';

  /**
   * Change plan.
   *
   * Changes the current plan for the organization. Requires ManageBilling.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSubscriptionChangePlanPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionChangePlanPost$Plain$Response(params?: BillingSubscriptionChangePlanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    const obs = billingSubscriptionChangePlanPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change plan.
   *
   * Changes the current plan for the organization. Requires ManageBilling.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSubscriptionChangePlanPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionChangePlanPost$Plain(params?: BillingSubscriptionChangePlanPost$Plain$Params, context?: HttpContext): Observable<SubscriptionDto> {
    const resp = this.billingSubscriptionChangePlanPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /**
   * Change plan.
   *
   * Changes the current plan for the organization. Requires ManageBilling.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSubscriptionChangePlanPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionChangePlanPost$Json$Response(params?: BillingSubscriptionChangePlanPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    const obs = billingSubscriptionChangePlanPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change plan.
   *
   * Changes the current plan for the organization. Requires ManageBilling.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSubscriptionChangePlanPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionChangePlanPost$Json(params?: BillingSubscriptionChangePlanPost$Json$Params, context?: HttpContext): Observable<SubscriptionDto> {
    const resp = this.billingSubscriptionChangePlanPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `billingSubscriptionUpdateSeatsPost()` */
  static readonly BillingSubscriptionUpdateSeatsPostPath = '/billing/subscription/update-seats';

  /**
   * Update seat assignments.
   *
   * Assigns/unassigns seats for users on the current subscription.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSubscriptionUpdateSeatsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionUpdateSeatsPost$Plain$Response(params?: BillingSubscriptionUpdateSeatsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    const obs = billingSubscriptionUpdateSeatsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update seat assignments.
   *
   * Assigns/unassigns seats for users on the current subscription.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSubscriptionUpdateSeatsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionUpdateSeatsPost$Plain(params?: BillingSubscriptionUpdateSeatsPost$Plain$Params, context?: HttpContext): Observable<SubscriptionDto> {
    const resp = this.billingSubscriptionUpdateSeatsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /**
   * Update seat assignments.
   *
   * Assigns/unassigns seats for users on the current subscription.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSubscriptionUpdateSeatsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionUpdateSeatsPost$Json$Response(params?: BillingSubscriptionUpdateSeatsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    const obs = billingSubscriptionUpdateSeatsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update seat assignments.
   *
   * Assigns/unassigns seats for users on the current subscription.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSubscriptionUpdateSeatsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  billingSubscriptionUpdateSeatsPost$Json(params?: BillingSubscriptionUpdateSeatsPost$Json$Params, context?: HttpContext): Observable<SubscriptionDto> {
    const resp = this.billingSubscriptionUpdateSeatsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

}
